import Vue from 'vue';
import VueRouter from 'vue-router';
import ErrorPage from '@/components/error-page';

// import Map from '@/views/map/index';

import Manage from '@/views/manage/index';
import ManageJournal from '@/views/manage/journal';
import DataManage from '@/views/data-manage/index';
import usercenter from '@/views/usercenter/index';
import login from '../views/login';
import parameter from '../views/manage/parameter.vue';

import List from '@/views/list/index';
import Plan from '@/views/plan/index';
import Preview from '@/views/3d/preview';

Vue.use(VueRouter);

const routes = [
  {
    name: 'login',
    path: '/login',
    component: login
  },
  {
    name: 'manage',
    path: '/manage',
    component: Manage
  },
  {
    path: '/',
    redirect: '/list'
  },
  {
    name: 'list',
    path: '/list',
    component: List
  },
  {
    name: 'project-list',
    path: '/project-list',
    component: Plan,
    children: [
      {
        name: 'resource-selection',
        path: 'resource-selection',
        components: {
          Modal: () => import('@/views/plan/components/resource-selection')
        }
      },

      {
        name: 'deploy',
        path: 'deploy',
        components: {
          Modal: () => import('@/views/plan/components/deploy')
        }
      },

      {
        name: 'power',
        path: 'power',
        components: {
          Modal: () => import('@/views/plan/components/power')
        }
      },
      {
        name: 'tower',
        path: 'tower',
        components: {
          Modal: () => import('@/views/plan/components/tower')
        }
      },

      {
        name: 'economic-evaluation',
        path: 'economic-evaluation',
        components: {
          Modal: () => import('@/views/plan/components/economic-evaluation')
        }
      }
    ]
  },
  {
    name: '3d-preview',
    path: '/3d/preview/:projectType',
    component: Preview
  },
  {
    name: 'manage-journal',
    path: '/manage/journal',
    component: ManageJournal
  },
  {
    name: 'manage/parameter',
    path: '/manage/parameter',
    component: parameter
  },
  {
    name: 'data-manage',
    path: '/data-manage',
    component: DataManage
  },
  {
    name: 'usercenter',
    path: '/usercenter',
    component: usercenter
  },
  {
    path: '*',
    components: ErrorPage,
    props: {
      Home: {
        type: '404'
      }
    }
  }
];

// 获取原型对象push函数
const originalPush = VueRouter.prototype.push
 
// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace
 
// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location){
return originalPush.call(this , location).catch(err=>err)
}
 
// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location){
return originalReplace.call(this , location).catch(err=>err)
}

export default new VueRouter({ routes });
